import { render, staticRenderFns } from "./PerformanceReviewTemplatesList.vue?vue&type=template&id=44452b2d&scoped=true&"
import script from "./PerformanceReviewTemplatesList.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewTemplatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44452b2d",
  null
  
)

export default component.exports